
import './copy.less'
import React from 'react'
const te = ['left', 'center', 'right']
console.log(React)

export default function BasicsCopy(props) {
  const ifon = props.ifon.ifon

  return (<div className='basicsTextCopy'>
    <p className='basicsTextCopy_text' style={{
      paddingTop: ifon.padding_top,
      paddingBottom: ifon.padding_bottom,
      justifyContent: te[ifon.text_alignment],
      fontSize: ifon.font_size + 'px',
      color: ifon.font_color,
      fontWeight: ifon.font_style ? 'bold' : 'normal'
    }}>{ifon.text}</p>
  </div>)
}
